import React from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import { cnMerge } from '../../../../utils/utils';
import { Stack } from '../../../atoms/stack/Stack';
import { Close } from '../../../../../static/icons/close';
import { Row } from '../../../atoms/row/Row';

const ModalHeader = ({
  imgUrl,
  imgAlt,
  onClose,
  singleLine,
  title,
  subtitle,
  className,
}) => (
  <Row
    className={cnMerge(className, `w-full  px-6 items-center justify-between`)}
  >
    <Row className="gap-3 items-center">
      {imgUrl && (
        <img
          className="w-16 h-16 rounded-full"
          src={imgUrl}
          alt={imgAlt ?? ''}
        />
      )}

      <Stack>
        {singleLine ? (
          <Typography
            fontVariant="md"
            textAlign="left"
            className="w-fit font-medium"
          >
            {title}
          </Typography>
        ) : (
          <>
            <Typography
              fontVariant="xs"
              textAlign="left"
              className="w-fit leading-none font-normal"
            >
              {title}
            </Typography>
            <Typography
              fontVariant="md"
              textAlign="left"
              className="w-fit leading-none font-medium"
            >
              {subtitle}
            </Typography>
          </>
        )}
      </Stack>
    </Row>
    <button
      type="button"
      onClick={onClose}
      aria-label="Close modal"
      className="flex justify-center items-center w-12 h-12 border border-customGray-300 rounded-xl global-hover"
    >
      <Close />
    </button>
  </Row>
);

export default ModalHeader;
